
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'Header' })
export default class Header extends Vue {
  @Prop() private text!: string;

  @Prop() private imageName!: string;

  @Prop() private titleText!: string;

  get image(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return `/img/fotos/${this.imageName}-mobile.jpg`;
      case 'sm':
      case 'md':
      case 'lg':
      case 'xl':
        return `/img/fotos/${this.imageName}-desktop.jpg`;
      default:
        return `/img/fotos/${this.imageName}-desktop.jpg`;
    }
  }
}
